module.exports = __webpack_public_path__ + "img/NOMBRESOLO.4f23ee62.png";